(function($){
  $(function(){
    /**
     * plugin settings
     * jquery 以外のライブラリもここで設定
     */
     // spとpcの出し分け定数
    var deviceSP = OH.browserInfo.isiOS || OH.browserInfo.isAndroid;
    var deviceSPMediaQuery = window.matchMedia('(max-width:600px)').matches;


    // top main visuale カルーセル
    var $navButtonPrev = '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#angle-left"></use></svg>';
    var $navButtonNext = '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#angle-right"></use></svg>';
    var delayTime = 4000; // テキストが表示されている時間
    var smartSpeedTime = 750; //切り替わりのときのスピード


    /**
     * カルーセルのスタートタイミングを遅らせる
     * @param {function}
     */
    var carouselTrigger = function carouselTrigger(owlFunction){
      setTimeout(function(){
        owlFunction.trigger('stop.owl.autoplay');
        setTimeout(function() {
          owlFunction.trigger('play.owl.autoplay');
        }, 4000);
      });
    }
    
     if(deviceSPMediaQuery){
       var spTopOwl = $('.mainVisual__sp').owlCarousel({
         items: 1,
         loop: true,
         autoplay: true,
         autoplayTimeout: delayTime,
         smartSpeed: smartSpeedTime,
        //  cssEasing: 'easeInOutCubic',
        // fallbackEasing: 'easeOutBounce',
         fallbackEasing: 'swing'
        //  onTranslated: carouselCallBackEvent//carouselのitemの移動が終わったら発火
       });
       carouselTrigger(spTopOwl);
     }else if(!deviceSPMediaQuery){
       var pcTopOwl = $('.mainVisual__pc').owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: delayTime,
        navClass:['prev-top','next-top'],
        navText: [ $navButtonPrev , $navButtonNext],
        dots: true,
        nav: true,
        smartSpeed: smartSpeedTime,
        // cssEasing: 'easeInOutCubic'
        // fallbackEasing: 'easeOutBounce'
        fallbackEasing: 'swing'
        // onTranslated: carouselCallBackEvent//carouselのitemの移動が終わったら発火
       });
       carouselTrigger(pcTopOwl);
     }

     //shop_menuのowlCarousel
     //スマホとタブレットの場合のみ発動
     var itemIndex = $('.shop_menu').find('.shop_menu__item').length;
    //  $(window).on('load resize',function(){
       if (window.matchMedia('(max-width:840px)').matches) {
         $(".shop_menu").owlCarousel({
           responsive: {
             0: {
               center: true,
               items: 1,
               loop: true,
               stagePadding: 80,
               dots: false,
              //  URLhashListener: true,
              //  startPosition: 'URLHash'
             },
             320: {
               center: true,
               items: 3,
               loop: true,
               stagePadding: 40,
               dots: false,
              //  URLhashListener: true,
              //  startPosition: 'URLHash'
             },
             590: {
               center: true,
               items: 7,
               loop: true,
               stagePadding: 10,
               dots: false,
              //  URLhashListener: true,
              //  startPosition: 'URLHash'
             },
             769: {
               items: itemIndex,
               dots: false,
              //  URLhashListener: true,
              //  startPosition: 'URLHash'
             }
           }
         });
       }
    // });

    //レストラン一覧のselect
    // PCのみ
    if(!deviceSPMediaQuery){
    // if(false){
      $('[data-castum-select]').each(function(){
        $(this).easySelectBox({speed:'fast'});
      });
      
    }
    // $('[data-castum-select2]').easySelectBox({speed:'fast'});
    // $('[data-rendering-trigger]').change(function(){
    //   
    // });

    // レストラン詳細ページ
    // jquery Pluginは基本的に指定domが onloadで走るので$(window).on('load')いらない
    // $(window).on('load',function(){
      $(".is-restaurant_detail").owlCarousel({
        items: 1,
        autoplay: true,
        autoplayTimeout: 3000,
        loop: true,
        dots: true
      });
    // });


    /**
     * object-fitをieで使うためのプラグイン宣言
     */
//     if(OH.browserInfo.isIE && OH.browserInfo.ver > 10 || OH.browserInfo.isEdge){
     if(OH.browserInfo.isIE && OH.browserInfo.ver > 10){
       objectFitImages('img.c-thumbnail__crop__img');
       objectFitImages('img.l-feature__list__item__keyvisual__img');
       var opacityImg = '/assets/images/opacity.png';
       $('img.c-thumbnail__crop__img, img.l-feature__list__item__keyvisual__img').each(function(){
         $(this).attr('src',opacityImg);
       });
     }

     /**
      * カルーセルコンポーネント 記述
      * .oc-carouselにdeta-属性を入れてオプション制御
      * spは固定オプション
      * SPでは表示領域を考慮してアイテムが必ず1つで、両サイドに次のアイテムが見切れています。
      */

      //これはPluginでのheightコントロール
      $('.oc-carousel .oc-thumbnail a .u-responsive').wrap('<div class="oc-thumbnail__imgWrap" />');
  		$('.oc-carousel .oc-thumbnail a .oc-thumbnail__imgWrap').matchHeight();
      
      if(deviceSPMediaQuery){
        $('.oc-carousel').each(function(){
          $(this).owlCarousel({
            margin:1,
            items: 1,
            loop: true,
            autoplay: true,
            autoplayTimeout: 8000,
            stagePadding:80,
            center: true
          });
        });
      } else{
        $('.oc-carousel').each(function(){
          // data属性にdeta-carousel-optionがあれば参照
          var carouselOptions = $(this).data(this,'carouselOption') ? $(this).data('carouselOption') : 'dots: true';
          var defaltOptions = {"items": 1,"loop": false,"autoplay": true,"autoplayTimeout": 8000};

          /**
           * オブジェクトをマージして引数obj1に全部入れる
           */
          var objMerge = function (obj1, obj2) {
            if (!obj2) {
                obj2 = {};
            }
            for (var attrname in obj2) {
                if (obj2.hasOwnProperty(attrname) && !obj1.hasOwnProperty(attrname)) {
                    obj1[attrname] = obj2[attrname];
                }
            }
          };
          objMerge(carouselOptions ,defaltOptions);
          $(this).owlCarousel(carouselOptions);
        });
      }
  });
})(jQuery);
